import { useCallback } from 'react';

import { useMytaverseEvent } from '@core/dashboard/providers';

export const useIsAIEnabledForEvent = () => {
  const { currentEventId, currentEvent } = useMytaverseEvent();

  return useCallback(() => {
    return !!(
      currentEventId &&
      currentEvent?.settings?.aiEnabled &&
      currentEvent?.settings?.aiVirtualAssistantName === 'Noa'
    );
  }, [currentEventId, currentEvent?.settings]);
};
